export default () => ({
  getComponent(nextState, cb) {
    require.ensure(
      [],
      (require) => {
        const LoginContainer = require('./containers/LoginContainer').default
        cb(null, LoginContainer)
      },
      'login'
    )
  },
})



// WEBPACK FOOTER //
// ./src/routes/Login/index.js